import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ReusableButton from "../Reusable/PrimaryButton/PrimaryButton";

const ComingSoon = () => {
  const navigate = useNavigate();

  const handleRoute = () => {
    navigate("/home");
  };


  return (
    <Box className="gradient-background height-main coming-soon-container"
    >
      <Typography variant="h3" fontWeight={600} gutterBottom className="coming-soon-title">
        Coming Soon!
      </Typography>
      <Typography variant="body1" gutterBottom className="coming-soon-description">
        We're working hard to bring you this feature. Stay tuned for updates!
      </Typography>
      <Box className="coming-soon-button-container">
      <ReusableButton onClick={handleRoute}>Back to Studio</ReusableButton>
      </Box>
    </Box>
  );
};

export default ComingSoon;